<template>
  <b-container>
    <template-breadcrumb-header-action-element>
      <template #content>
        <b-button
          variant="primary"
          block
          @click="goToModel()"
          id="report-button"
        >
            <i class="bi bi-file-bar-graph"></i>
            {{ $t("label_evaluation_check_report") }}
        </b-button>
      </template>
    </template-breadcrumb-header-action-element>
    <evaluation-model-header
      v-if="!selectedRequirement"
      :data="data"
      :is-report="false"
      :evaluation-data="evaluationData"
      :organizations="organizations"
    />
    <b-tabs
      style="margin-top: -5px;"
      active-nav-item-class="active-tab"
      v-if="!selectedRequirement" content-class="mt-3">
      <b-tab :title-link-class="'tab-font'" style="margin-top: -5px;" :title="$t('label_evaluation_shortTitle')" active>
        <evaluation-audit-tab />
      </b-tab>
      <b-tab :title-link-class="'tab-font'" style="margin-top: -5px;" :title="$t('label_evaluation_opportunitiesImprovement_title')">
        <evaluation-improvement-tab :account="account" />
      </b-tab>
      <b-tab :title-link-class="'tab-font'" style="margin-top: -5px;" :title="$t('label_evaluation_summary_title')">
        <evaluation-summary-tab />
      </b-tab>
      <b-tab :title-link-class="'tab-font'" style="margin-top: -5px;" :title="$t('label_evaluation_organization_info')">
        <evaluation-organization-info-tab :evaluationData="evaluationData" :organizations="organizations"/>
      </b-tab>
      <b-tab :title-link-class="'tab-font'" style="margin-top: -5px;" :title="$t('label_evaluation_records_title')">
        <audit-records-tab/>
      </b-tab>
    </b-tabs>
    <template-evaluation-navigation-buttons
      v-if="selectedRequirement"
      :is-previous-enabled="isPreviousEnabled"
      :is-next-enabled="isNextEnabled"
      @moveEvaluatingNode="moveEvaluatingNode"
      @clearEvaluatingNode="clearEvaluatingNode"
    />
    <b-row v-if="selectedRequirement">
      <b-col class="mt-2">
        <evaluation-evaluate-node :evaluation-id="evaluationId" />
      </b-col>
    </b-row>
    <template-evaluation-navigation-buttons
      v-if="selectedRequirement"
      :is-previous-enabled="isPreviousEnabled"
      :is-next-enabled="isNextEnabled"
      style="margin-bottom: 30px"
      @moveEvaluatingNode="moveEvaluatingNode"
      @clearEvaluatingNode="clearEvaluatingNode"
    />
  </b-container>
</template>

<script>
import EvaluationEvaluateNode from "./EvaluationEvaluateNode";
import EvaluationModelHeader from "../shared/EvaluationHeader";
import EvaluationAuditTab from "./EvaluationAuditTab";
import EvaluationImprovementTab from "./EvaluationImprovementTab";
import AuditRecordsTab from "./AuditRecordsTab";
import EvaluationSummaryTab from "../shared/EvaluationSummaryTab";
import EvaluationOrganizationInfoTab from "./EvaluationOrganizationInfoTab";

import evaluationDataMixin from "@/components/modules/evaluation/mixins/evaluationDataMixin";
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";


export default {
  name: "EvaluationEvaluate",
  components: {
    EvaluationModelHeader,
    EvaluationEvaluateNode,
    EvaluationAuditTab,
    EvaluationImprovementTab,
    EvaluationSummaryTab,
    EvaluationOrganizationInfoTab,
    AuditRecordsTab
  },
  mixins: [evaluationDataMixin],
  data: function () {
    return {
      showModalSummary: false,
      path: [],
      evaluationId: this.$route.params.idEvaluation,
      evaluationData: { evaluation: {} },
      status: "success",
      summary: "",
      refreshCount: 0,
      selectedRequirement: null,
      isOrganization: false,
      organizations: [],
      position: ''

    };
  },
  computed: {
    ...mapGetters(["getSelectedRequirement", "getIsLoading"]),
  },
  async created() {
   // await axiosCall({ url: "/Evaluations/export", method: "GET" });
    this.$store.commit("CLEAR_EVALUATION_STORE");
    this.evidencesRequested = false;
    await this.getEvaluations();
    await this.loadBusinessAndSnapshotInfo()
  },

  watch: {
    getSelectedRequirement: function () {
      this.selectedRequirement = cloneDeep(this.getSelectedRequirement);
    },
  },
  methods: {

    loadBusinessAndSnapshotInfo: async function(){
      var businessData = await this.getBusiness(this.evaluationData.businessId)
      var snapshotData = await this.getSnapshots(this.evaluationData.snapshotId)
      var selfassessmentsData = await this.getSelfAssessment(this.evaluationData.snapshotId)

      for(var i=0; i < this.evaluationData.businessId.length; i++){
        let temp = Object.assign(businessData[i], snapshotData[i])
        temp = Object.assign(temp, selfassessmentsData[i])
        this.organizations.push(temp)
      }

      this.organizations.length = this.evaluationData.businessId.length
    },
    getBusiness: async function(ids){
      var data = ids
      var temp
        await axiosCall({ url: "/Businesses/getMultiple", method: "POST", data})
            .then((response) => {
                temp = response.data
            })
            .catch(() => {
        });
        return temp
    },
    getSnapshots: async function(ids){
      var data = ids
      var temp
        await axiosCall({ url: "/Snapshots/getMultiple", method: "POST", data})
            .then((response) => {
                temp = response.data
            })
            .catch(() => {
        });
        return temp
    },
    getSelfAssessment: async function(ids){
      var data = ids
      var temp
        await axiosCall({ url: "SelfAssessments/getMultiple/", method: "POST", data})
            .then((response) => {
                temp = response.data
            })
            .catch(() => {
        });
        return temp
    },
    goToModel() {
      this.$router.push("/evaluation/report/" + this.evaluationId);
    },

    closeModalSummary() {
      this.showModalSummary = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/variables";

.cardContainer {
  border: 1px solid #000000;
  width: 100%;
  padding: 30px 40px;
}

.cardContainer h5 {
  text-align: center;
  width: 100%;
}

h2 {
  color: black;
  margin: 1em 0;
}

.label {
  font-weight: bold;
  font-size: 14px;
}

.h7 {
  font-weight: bold;
}

h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
}

.vtl-icon-caret-down:before {
  content: "\e901";
}

.vtl-icon-caret-right:before {
  content: "\e900";
}


.h3{
  text-align: center;
  width: 100px;
  font-size: 20px;
  font-family: $font-subtitle;
  text-transform: uppercase;
  }

#report-button{
  max-width: 175px;
    max-width: 175px;
  max-width: 175px;
  max-height:40px;
}
</style>
